export class TestReport {
  // Detects the running browser name, version and platform.
  static getSystemInfo = function () {
    // Code inspired by http://goo.gl/9dZZqE with
    // added support of modern Internet Explorer versions (Trident).
    if (typeof navigator === 'undefined') {
      return
    }
    const agent = navigator.userAgent
    let browserName = navigator.appName
    let version = '' + parseFloat(navigator.appVersion)
    let offsetName
    let offsetVersion
    let ix

    if ((offsetVersion = agent.indexOf('Chrome')) !== -1) {
      browserName = 'Chrome'
      version = agent.substring(offsetVersion + 7)
    } else if ((offsetVersion = agent.indexOf('MSIE')) !== -1) {
      browserName = 'Microsoft Internet Explorer' // Older IE versions.
      version = agent.substring(offsetVersion + 5)
    } else if ((offsetVersion = agent.indexOf('Trident')) !== -1) {
      browserName = 'Microsoft Internet Explorer' // Newer IE versions.
      version = agent.substring(offsetVersion + 8)
    } else if ((offsetVersion = agent.indexOf('Firefox')) !== -1) {
      browserName = 'Firefox'
    } else if ((offsetVersion = agent.indexOf('Safari')) !== -1) {
      browserName = 'Safari'
      version = agent.substring(offsetVersion + 7)
      if ((offsetVersion = agent.indexOf('Version')) !== -1) {
        version = agent.substring(offsetVersion + 8)
      }
    } else if (
      (offsetName = agent.lastIndexOf(' ') + 1) <
      (offsetVersion = agent.lastIndexOf('/'))
    ) {
      // For other browsers 'name/version' is at the end of userAgent
      browserName = agent.substring(offsetName, offsetVersion)
      version = agent.substring(offsetVersion + 1)
      if (browserName.toLowerCase() === browserName.toUpperCase()) {
        browserName = navigator.appName
      }
    } // Trim the version string at semicolon/space if present.
    if ((ix = version.indexOf(';')) !== -1) {
      version = version.substring(0, ix)
    }
    if ((ix = version.indexOf(' ')) !== -1) {
      version = version.substring(0, ix)
    }
    return {
      browserName: browserName,
      browserVersion: version,
      platform: navigator.platform,
    }
  }

  settings: any
  output: any[] = []
  nextAsyncId = 0

  constructor(settings: any) {
    this.settings = settings

    // Hook up window.onerror logs into the report.
    if (typeof window !== 'undefined') {
      window.addEventListener('error', this.onWindowError.bind(this))
    }

    this.traceEventInstant('system-info', TestReport.getSystemInfo())
  }

  traceEventAsync(name: string) {
    return this.traceEventInstant.bind(this, name, this.nextAsyncId++)
  }

  traceEventInstant(name: string, args: any) {
    this.write({
      ts: Date.now(),
      name: name,
      args: args,
    })
  }

  traceEventWithId(name: string, id: string, args: any) {
    this.write({
      ts: Date.now(),
      name: name,
      id: id,
      args: args,
    })
  }

  write(data: any) {
    //console.log(data)
    //console.debug(prefix, message)
    this.output.push(data)
  }

  generate(bugDescription: string) {
    const header = {
      title: 'WebRTC Troubleshooter bug report',
      description: bugDescription || null,
    }
    return this.getContent(header)
  }

  // Returns the logs into a JSON formated string that is a list of events
  // similar to the way chrome devtools format uses. The final string is
  // manually composed to have newlines between the entries is being easier
  // to parse by human eyes. If a contentHead object argument is provided it
  // will be added at the top of the log file.
  getContent(contentHead: any) {
    const stringArray: string[] = []
    this.appendEventsAsString([contentHead] || [], stringArray)
    this.appendEventsAsString(this.output, stringArray)
    return '[' + stringArray.join(',\n') + ']'
  }

  appendEventsAsString(events: any[], output: any[]) {
    for (let i = 0; i !== events.length; ++i) {
      output.push(JSON.stringify(events[i]))
    }
  }

  onWindowError(error: any) {
    this.traceEventInstant('error', {
      message: error.message,
      filename: error.filename + ':' + error.lineno,
    })
  }

  logHook() {
    this.traceEventInstant('log', arguments)
  }
}
